import React, { Component } from "react";
import {
  NotificationContainer,
  NotificationManager
} from "react-notifications";
import "../../node_modules/react-notifications/lib/notifications.css";
class WebNotif extends Component {
  state = {};
  createNotification = (type, msg) => {
    switch (type) {
      case "info":
        NotificationManager.info("Info message","",10000);
        break;
      case "success":
        NotificationManager.success(msg,"",10000);
        break;
      case "warning":
        NotificationManager.warning(msg,"",10000);
        break;
      case "error":
        NotificationManager.error(msg,"",10000);
        break;
    }
  };
  render() {
    return null;
  }
}
export default WebNotif;
